
import { IEntity } from "@interfaces/entity";

export class ConfirmationCodeDto {

  id: number;
  created?: Date;
  consumed?: boolean;
  code?: string;
  userId?: string;
  email?: string;



  constructor() {
    this.id = 0;
    this.code = "";
    this.userId = "";
    this.email = "";
  }
}
